import { useRef, useState } from 'react'

import t from '../helpers/i18n'

const UNINITIALIZED = 0
const LOADING = 1
const RELOADING = 2
const ERROR = 3
const READY = 4

const generateState = (state, data) => {
  if (state < UNINITIALIZED || state > READY) throw new Error(t('Invalid state'))
  return [state, data]
}

const useVisualState = (state = UNINITIALIZED, data = undefined) => {
  const [, forceUpdate] = useState({})
  const visualState = useRef(generateState(state, data))
  const [setVisualState, ] = useState(() => {
    return (newState, newOptions = undefined) => {
      if (newState === RELOADING) {
        visualState.current = generateState(LOADING, newOptions || visualState.current[1])
      } else {
        visualState.current = generateState(newState, newOptions)
      }
      forceUpdate({})
    }
  })
  return [visualState.current, setVisualState]
}

export {
  useVisualState,
  UNINITIALIZED,
  LOADING,
  RELOADING,
  ERROR,
  READY
}
